/**
 * Hides the floating Pandectes "Change your consent" widget once a visitor
 * has made an initial cookie choice (Accept/Decline/Save preferences), and
 * exposes window.WRCookieSettings.open() so any on-page trigger (e.g. the
 * footer "Cookie Settings" link) can reopen the same preferences dialog.
 *
 * Detection of "has the visitor made a choice" is delegated to Shopify's own
 * Customer Privacy API (already used elsewhere in this theme for Google
 * Consent Mode / ShopMy), since it is the authoritative, app-agnostic signal.
 * The Pandectes shadow DOM is only touched to hide/show the widget button and
 * to simulate a click on it to reopen the dialog.
 */
(function () {
  var STORAGE_KEY = 'wr_cookie_consent_interacted';
  var HOST_SELECTOR = 'pandectes-cmp';
  var WIDGET_SELECTOR = '.widget';

  function getHost() {
    return document.querySelector(HOST_SELECTOR);
  }

  function getShadowRoot() {
    var host = getHost();
    return host ? host.shadowRoot : null;
  }

  function getWidget(shadowRoot) {
    return shadowRoot ? shadowRoot.querySelector(WIDGET_SELECTOR) : null;
  }

  function setStoredInteraction() {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      /* localStorage unavailable (private mode, etc.) - fail silently */
    }
  }

  function hasStoredInteraction() {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function hasConsentInteraction() {
    if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.currentVisitorConsent === 'function'
    ) {
      try {
        var consent = window.Shopify.customerPrivacy.currentVisitorConsent();
        if (consent) {
          var interacted = Object.keys(consent).some(function (key) {
            return consent[key] === 'yes' || consent[key] === 'no';
          });
          if (interacted) {
            return true;
          }
        }
      } catch (e) {
        /* ignore and fall back to stored flag */
      }
    }

    return hasStoredInteraction();
  }

  function hideWidget(widget) {
    if (!widget) return;
    widget.style.setProperty('display', 'none', 'important');
    widget.setAttribute('aria-hidden', 'true');
    widget.setAttribute('tabindex', '-1');
  }

  function showWidget(widget) {
    if (!widget) return;
    widget.style.removeProperty('display');
    widget.removeAttribute('aria-hidden');
    widget.removeAttribute('tabindex');
  }

  function applyState() {
    var shadowRoot = getShadowRoot();
    var widget = getWidget(shadowRoot);
    if (!widget) return;

    if (hasConsentInteraction()) {
      hideWidget(widget);
    } else {
      showWidget(widget);
    }
  }

  function watchForRerenders(shadowRoot) {
    if (!shadowRoot || !window.MutationObserver) return;

    var observer = new MutationObserver(function () {
      applyState();
    });

    observer.observe(shadowRoot, { childList: true, subtree: true });
  }

  function init() {
    var shadowRoot = getShadowRoot();

    if (shadowRoot) {
      applyState();
      watchForRerenders(shadowRoot);
      return;
    }

    if (!window.MutationObserver) return;

    var bodyObserver = new MutationObserver(function () {
      var foundShadowRoot = getShadowRoot();
      if (foundShadowRoot) {
        applyState();
        watchForRerenders(foundShadowRoot);
        bodyObserver.disconnect();
      }
    });

    bodyObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener('visitorConsentCollected', function () {
    setStoredInteraction();
    applyState();
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cookie-settings-trigger]');
    if (!trigger) return;
    event.preventDefault();
    window.WRCookieSettings.open();
  });

  window.WRCookieSettings = {
    open: function () {
      var widget = getWidget(getShadowRoot());
      if (widget) {
        widget.click();
      }
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
